module.exports = __webpack_public_path__ + "static/media/car-claim-card.c57438b0.svg";